import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../components/main_comps/custom_button";
import { colorDarkBlue } from "../../../../utility/constants/colorManager";
import { AiOutlinePlus } from "react-icons/ai";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import CustomModal from "../../../components/main_comps/custom_modal";
import OnboardUserIndex from "./onboard_user";
import SelectManagement from "./onboard_user/SelectManagement";
import custom_getvalue from "../../../components/main_comps/custom_getvalue";

const Container = ({ title, value, styles }) => {
  return (
    <div style={{ display: "flex", marginBottom: "20px" }}>
      <p
        style={{
          color: "#000000",
          fontSize: "14px",
          fontWeight: "500",
          width: "180px",
        }}
      >
        {title}
      </p>

      <p style={{ color: "#3A3A3A", fontSize: "14px", ...styles }}>{value}</p>
    </div>
  );
};

const Container2 = ({ title, value }) => {
  return (
    <div style={{ display: "flex", marginBottom: "20px" }}>
      <p
        style={{
          color: "#000000",
          fontSize: "14px",
          fontWeight: "500",
          width: "180px",
        }}
      >
        {title}
      </p>
      <ul style={{ margin: 0, padding: 0, paddingLeft: 10 }}>
        {value.map((e) => (
          <li
            style={{
              color: "#3A3A3A",
              fontSize: "14px",
              lineHeight: 2,

              listStyleType: "disc",
            }}
            key={e.length}
          >
            {e.acl_name}
          </li>
        ))}
      </ul>
    </div>
  );
};

const Container3 = ({ value, width }) => {
  return (
    <div style={{ display: "flex", marginBottom: "20px" }}>
      <ul
        style={{
          textAlign: "start",
          minWidth: "300px",
        }}
      >
        {value.map((e) => (
          <li
            style={{
              color: "#3A3A3A",
              fontSize: "14px",
              lineHeight: 2,
              listStyleType: "disc",
              textAlign: "start",
            }}
          >
            {e.acl_name}
          </li>
        ))}
      </ul>
    </div>
  );
};

const inputStyle = {
  backgroundColor: "#F3F3F3",
  alignSelf: "center",
  height: 40,
  boxShadow: "none",
  outline: "none",
  paddingLeft: 10,
  boxSizing: "border-box",
  borderRadius: "5px",
  width: "100%",
};
const containerStyle = {
  padding: 0,
  maxWidth: 300,
  minWidth: "250px",
  width: "100%",
  height: "40px",
};

const BasicDetails = ({ data, isEditClicked = false, onChange, width }) => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [role, setRole] = useState("");
  const [onClickEdit, setOnClickEdit] = useState(false);

  const [userAclList, setUserAclList] = useState([]);

  useEffect(() => {
    onChange({
      firstName: custom_getvalue(firstName, data?.firstName),
      lastName: custom_getvalue(lastName, data?.lastName),
      email: custom_getvalue(email, data?.email),
      mobileNumber: custom_getvalue(mobileNumber, data?.mobileNumber),
    });
  }, [firstName, lastName, email, mobileNumber]);

  useEffect(() => {
    setFirstName(data?.firstName);
    setLastName(data?.lastName);
    setEmail(data?.email);
    setMobileNumber(data?.mobileNumber);
  }, [isEditClicked, data]);

  const getAclList = () => {
    ApiRequestGet.getAclList({
      user_id: data?.userId,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          setUserAclList(response.data.aclList);
        }
      })
      .catch((error) => {
        console.log(error, "err");
      });
  };
  useEffect(() => {
    getAclList();
  }, []);

  return (
    <div
      style={{
        padding: "10px 20px",
        flexWrap: "wrap",
        display: "flex",
        flexDirection: "row",
      }}
    >
      {isEditClicked ? (
        <>
          <div style={{ width: "50%", minWidth: "400px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"First Name"}
              </p>
              <CustomInput
                value={firstName}
                onChange={(data) => setFirstName(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="First Name"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Last Name"}
              </p>
              <CustomInput
                value={lastName}
                onChange={(data) => setLastName(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Last Name"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Email Id"}
              </p>
              <CustomInput
                value={email}
                onChange={(data) => setEmail(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Email id"
                validator="email"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Mobile number"}
              </p>
              <CustomInput
                value={mobileNumber}
                onChange={(data) => setMobileNumber(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Mobile number"
                validator="mobile"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
                minWidth: "500px",
              }}
            >
              <div
                style={{
                  width: "180px",
                }}
              >
                <p
                  style={{
                    color: "#000000",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  {"Role"}
                </p>
              </div>

              <div
                style={{
                  maxWidth: "350px",
                  minWidth: "300px",
                }}
              >
                <p
                  style={{
                    textAlign: "start",
                    paddingLeft: "15px",
                  }}
                >
                  {data.role}
                </p>
              </div>

              <CustomButton
                title={"Edit"}
                styles={{
                  backgroundColor: colorDarkBlue,
                  border: "none",
                }}
                onClick={() => {
                  setOnClickEdit(true);
                }}
                icon={<AiOutlinePlus color="white" />}
              ></CustomButton>
            </div>

            <div
              style={{
                display: "flex",
                minWidth: "500px",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: width > 640 ? "0px" : "180px",
                  textAlign: "start",
                  minWidth: 100,
                }}
              >
                {"Features"}
              </p>

              <Container3 value={userAclList} />

              <CustomButton
                title={"Edit"}
                styles={{
                  backgroundColor: colorDarkBlue,
                  border: "none",
                }}
                onClick={() => {
                  setOnClickEdit(true);
                }}
                icon={<AiOutlinePlus color="white" />}
              ></CustomButton>
            </div>
          </div>
        </>
      ) : (
        <div style={{ padding: "10px 20px" }}>
          <Container
            title="Name:"
            value={data?.firstName + " " + data?.lastName}
            styles={{
              textTransform: "capitalize",
            }}
          />
          <Container title="Email ID:" value={data?.email} />
          <Container
            title="Mobile Number:"
            value={"+91 " + data?.mobileNumber}
          />
          <Container title="Role:" value={data?.role} />

          <Container2 title="Features Assigned:" value={userAclList} />
        </div>
      )}

      {onClickEdit && (
        <CustomModal
          headerTitle=""
          open={onClickEdit}
          onClose={() => {
            setOnClickEdit(false);
          }}
          containerStyle={{
            width: "auto",
            height: "auto ",
          }}
        >
          <SelectManagement
            onClose={() => {
              setOnClickEdit(false);
            }}
            edit={true}
            aclFeatures={userAclList}
            role={data?.role}
            userId={data?.userId}
            onClickCancel={() => setOnClickEdit(false)}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default BasicDetails;
